import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type {
  ReportBlockType,
  ReportBlockPayloadType,
} from "@/common/types/report";

export async function reportBlockList(
  account_id: string,
  query?: { [key: string]: any },
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${account_id}/report/block/list${queryString}`,
  );
}

export async function reportBlockCreate(account_id: string, payload: any) {
  return await clientAxios.post(
    `account/${account_id}/report/block/create`,
    payload,
  );
}

export async function reportBlockPatch(
  account_id: string,
  block_id: string,
  payload: Partial<ReportBlockType>,
) {
  return await clientAxios.patch(
    `account/${account_id}/report/block/${block_id}/patch`,
    { payload },
  );
}

export async function reportBlockReorder(
  account_id: string,
  report_id: string,
  blocks: string[],
) {
  return await clientAxios.post(
    `account/${account_id}/report/${report_id}/block/reorder`,
    {
      blocks,
    },
  );
}

export async function reportBlockDelete(account_id: string, block_id: string) {
  return await clientAxios.del(
    `account/${account_id}/report/block/${block_id}/delete`,
  );
}
